import React, { useState } from "react";
import {
  Dropdown,
  FormControl,
  InputGroup,
  Button,
  Spinner,
} from "react-bootstrap";
import "../common.css";
import "./BookSearchBar.css";
import { searchBooks, askOpenai } from "../api";
import { FaSearch } from "react-icons/fa";

function BookSearchBar({
  setNewTitle,
  setNewAuthor,
  setNewDescription,
  setNewPageCount,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const blurAll = () => {
    if (document.activeElement && document.activeElement !== document.body) {
      document.activeElement.blur();
    }
  };

  const handleSearchIconClick = () => {
    const handleApiCalls = async () => {
      if (searchQuery.length) {
        setIsLoading(true);
        const books = await searchBooks(searchQuery);
        setIsLoading(false);
        const slicedBooks = books.slice(0, 3);

        const booksMap = new Map();
        const order = [];

        slicedBooks.forEach((book) => {
          const key = `${book.volumeInfo.title} by ${
            book.volumeInfo.authors ? book.volumeInfo.authors.join(", ") : ""
          }`.toLowerCase();
          if (booksMap.has(key)) {
            const existingBook = booksMap.get(key);
            if (
              existingBook.volumeInfo.pageCount === 0 &&
              book.volumeInfo.pageCount !== 0
            ) {
              existingBook.volumeInfo.pageCount = book.volumeInfo.pageCount;
            }
            if (
              (book.volumeInfo.description &&
                !existingBook.volumeInfo.description) ||
              (book.volumeInfo.description &&
                existingBook.volumeInfo.description &&
                String(book.volumeInfo.description).length !== 0 &&
                String(book.volumeInfo.description).length <
                  String(existingBook.volumeInfo.description).length)
            ) {
              existingBook.volumeInfo.description = book.volumeInfo.description;
            }
          } else {
            booksMap.set(key, book);
            order.push(key);
          }
        });

        const filteredBooks = order.map((key) => {
          const thisBook = booksMap.get(key);
          return {
            title: thisBook.volumeInfo.title,
            authors: thisBook.volumeInfo.authors
              ? String(thisBook.volumeInfo.authors.join(", "))
              : "Author information unavailable",
            description: thisBook.volumeInfo.description
              ? String(thisBook.volumeInfo.description)
              : "Description unavailable",
            pageCount: thisBook.volumeInfo.pageCount
              ? String(thisBook.volumeInfo.pageCount)
              : "Page Count unavailable",
          };
        });
        setFilteredData(filteredBooks);
        setShowDropdown(true);
      } else {
        setShowDropdown(false);
      }
    };
    handleApiCalls();
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setShowDropdown(false);
  };

  const handleSelection = async (item) => {
    setIsLoading(true);
    const processedDescription = await askOpenai(
      item.description,
      item.authors,
      item.title
    );
    setIsLoading(false);
    setSearchQuery("");
    setNewTitle(item.title);
    setNewAuthor(item.authors);
    setNewPageCount(item.pageCount);
    setNewDescription(processedDescription);
    blurAll();
  };

  return (
    <div>
      {isLoading && (
        <div className="overlay">
          <Spinner animation="border" />
        </div>
      )}
      <Dropdown show={showDropdown} onToggle={() => setShowDropdown(false)}>
        <InputGroup
          className={`outer-search-bar ${
            isFocused ? "outer-search-bar-focused" : ""
          }`}
        >
          <Dropdown.Toggle
            as={FormControl}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder="Type to search..."
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
            className="book-search-bar"
          />
          <Button
            className="book-search-bar-button"
            onClick={handleSearchIconClick}
          >
            <FaSearch />
          </Button>
        </InputGroup>
        <Dropdown.Menu className="input-box">
          {filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <Dropdown.Item
                className="search-item"
                key={index}
                onClick={() => handleSelection(item)}
              >
                <b>{item.title}</b>
                {item.authors !== "Author information unavailable" && (
                  <i> by {item.authors}</i>
                )}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item className="search-item">
              No Results Found
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default BookSearchBar;
